import { render, staticRenderFns } from "./ydruwangxy.vue?vue&type=template&id=11ee7494&scoped=true"
import script from "./ydruwangxy.vue?vue&type=script&lang=js"
export * from "./ydruwangxy.vue?vue&type=script&lang=js"
import style0 from "./ydruwangxy.vue?vue&type=style&index=0&id=11ee7494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ee7494",
  null
  
)

export default component.exports